import { RiEyeLine, RiFingerprintLine, RiLoginBoxLine, RiShieldCheckLine, RiTimeLine } from 'react-icons/ri';
import { CanvasStage } from './CanvasStage';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { useAuthStore } from '../state/authStore';
import { CLASSIFICATION_LABEL, PRIORITY_LABEL } from '../state/domain';
import { formatDay } from '@/lib/utils';

/** 只读共享演示外壳：极简页头 + 只读关联墙。 */
export function ShareView() {
  const snapshot = useAuthStore(state => state.shareSnapshot);
  const exitShare = useAuthStore(state => state.exitShare);
  const authed = useAuthStore(state => state.status === 'authed');

  if (!snapshot) return null;
  const { engagement, stats, share } = snapshot;

  return (
    <div className="grid h-full grid-rows-[46px_1fr]">
      <header className="flex items-center gap-3 border-b border-border bg-card px-4">
        <div className="flex items-center gap-2">
          <div className="grid size-7 place-items-center rounded-[7px] bg-primary text-primary-foreground">
            <RiFingerprintLine className="size-3.5" />
          </div>
          <span className="text-[12px] font-semibold tracking-[0.16em]">EXPOTAR</span>
        </div>

        <div className="h-5 w-px bg-border" />

        <Badge variant="assess" className="gap-1">
          <RiEyeLine className="size-3" />
          只读演示
        </Badge>

        <span className="truncate text-[12.5px] font-medium">{engagement.name}</span>
        {engagement.caseNo && (
          <span className="font-mono text-[10px] text-muted-foreground">{engagement.caseNo}</span>
        )}

        <Badge
          variant={
            engagement.classification === 'secret' || engagement.classification === 'confidential' ? 'cord' : 'outline'
          }
        >
          {CLASSIFICATION_LABEL[engagement.classification]}
        </Badge>
        {engagement.priority !== 'normal' && (
          <Badge variant="assess">优先级 {PRIORITY_LABEL[engagement.priority]}</Badge>
        )}

        <div className="flex-1" />

        <div className="hidden items-center gap-1.5 md:flex">
          <Stat label="对象" value={stats.targets} />
          <Stat label="线索" value={stats.entities} />
          <Stat label="关系" value={stats.relations} />
          <Stat label="证据" value={stats.evidence} />
          <Stat label="研判" value={stats.hypotheses} />
          <Stat label="事件" value={stats.timeline} />
        </div>

        {share.expiresAt && (
          <Badge variant="outline" className="gap-1">
            <RiTimeLine className="size-3" />
            至 {formatDay(share.expiresAt)}
          </Badge>
        )}

        {authed ? (
          <Button size="sm" variant="outline" onClick={exitShare}>
            返回工作台
          </Button>
        ) : (
          <Button size="sm" variant="outline" onClick={exitShare}>
            <RiLoginBoxLine className="size-3.5" />
            登录使用
          </Button>
        )}
      </header>

      <main className="relative flex min-h-0">
        <CanvasStage />
        <div className="pointer-events-none absolute bottom-3 left-1/2 z-20 flex -translate-x-1/2 items-center gap-1.5 rounded-full border border-border bg-card/92 px-3 py-1 text-[10.5px] text-muted-foreground shadow-sm backdrop-blur">
          <RiShieldCheckLine className="size-3 text-[var(--color-evidence)]" />
          只读快照 · 可平移缩放查看，不可编辑 · 不包含账号与审计数据
        </div>
      </main>
    </div>
  );
}

function Stat({ label, value }: { label: string; value: number }) {
  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-border px-2 py-[3px] text-[10px]">
      <span className="text-muted-foreground">{label}</span>
      <span className="font-mono font-medium">{value}</span>
    </span>
  );
}